import { ProductAnalysisGroup1 } from '../../entities/control-tables/product-analysis-group1-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class ProductAnalysisGroup1Request extends BaseRequest {
             
    productAnalysisGroup1 : ProductAnalysisGroup1

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productAnalysisGroup1 = new ProductAnalysisGroup1()
  }
}